import { createContext, useRef, useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

import LogoutWarningModal from "../_components/logout-warning-modal/logout-warning-modal.component";
import isKiosk from "../_services/kiosk/kiosk.service";

const TOTAL_TIME = 2 * 60; // 2 minutes

export const AutoLogoutContext = createContext({
  softResetTimer: () => {},
  hardResetTimer: ()=>{},
  removeTimer: () => {},
  hardRemoveTimer: () => {},
});

export const AutoLogoutProvider = ({ children }) => {
  const history = useHistory();
  const location = useLocation();

  const [remainingTime, setRemainingTime] = useState(TOTAL_TIME);
  const [preventSoftReset, setPreventSoftReset] = useState(false);
  //   const [showModal, setShowModal] = useState(false);
  const preventSoftResetRef = useRef(preventSoftReset);
  const timeoutIntervalRef = useRef(null);

  const addTimer = () => {
    const user = localStorage.getItem("user");
    if (!user) return;
    if(preventSoftResetRef.current) return;

    if (!isKiosk()) return;

    if (!timeoutIntervalRef.current) {
      timeoutIntervalRef.current = setInterval(() => {
        setRemainingTime((prev) => {
          if (prev <= 1) {
            logoutUser();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
  };

  const removeTimer = () => {
    if (timeoutIntervalRef.current) {
      clearInterval(timeoutIntervalRef.current);
      timeoutIntervalRef.current = null;
    }
  };

  const hardRemoveTimer = ()=>{
    setPreventSoftReset(true);
    removeTimer();
  }

  const logoutUser = () => {
    removeTimer();
    history.push("/logout");
  };

  const softResetTimer = () => {
    setRemainingTime(TOTAL_TIME);
    addTimer();
  };

  const hardResetTimer = ()=>{
    setPreventSoftReset(false);
    //keeping it here and also in use effect because if we update false the value is already false then this doesn't run and if this runs with previous value then it doesn't matter as it will run again with new value
    //? yes I can do prev value === new value but it doesn't matter as if we have to run it for false and for true it will just return 
    softResetTimer();  
  }

  useEffect(() => {
    // Start the countdown
    addTimer();
    const activityHandler = () => {
      softResetTimer();
    };

    const events = ["click", "keydown"];
    events.forEach((e) => window.addEventListener(e, activityHandler));

    return () => {
      removeTimer();
      events.forEach((e) => window.removeEventListener(e, activityHandler));
    };
  }, []);

  useEffect(()=>{
    console.log("here render");
    softResetTimer();
    preventSoftResetRef.current = preventSoftReset;
  },[preventSoftReset])

  useEffect(() => {
    hardResetTimer();
  }, [location]);

  const showModal = remainingTime <= 30 && remainingTime > 0;

  const value = {
    softResetTimer,
    hardResetTimer,
    removeTimer,
    hardRemoveTimer
  }

  return (
    <AutoLogoutContext.Provider value={value}>
      {showModal && (
        <LogoutWarningModal
          countdown={remainingTime}
          onStayLoggedIn={softResetTimer}
        />
      )}

      {children}
    </AutoLogoutContext.Provider>
  );
};
